import { ReduxService } from 'dashboard-services/services';

import { basicDataStorageCreatorActions as basicActions } from 'actions/modules/dataStorage/creator';

export const basicInitialState = {
  addDataExpanded: true,
  choosenItem: undefined,
  executing: false,
  footerExpanded: false,

  id: undefined,

  saved: true,
  settingsExpanded: false,
  downloadListenerEnable: false,
  statuses: undefined,

  zIndexStack: []
}

export default (state = basicInitialState, action) => {
  switch (action.type) {
    case basicActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicActions.BRING_TO_FRONT: {
      if(state.zIndexStack?.[state.zIndexStack?.length - 1] === action.value) {
        return state;
      }
      return ReduxService.updateObject(state, { zIndexStack: state.zIndexStack.filter(name => name !== action.value).add(action.value) })
    }
    case basicActions.CLEAR:
      return basicInitialState;
    default:
      return state; 
  }
}